import React from 'react'

const CompletedIcon = ({width=24,height=24}) => {
  return (
          <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.3006 6.20337L10.0039 12.5L6.85645 9.3517" stroke="#0AC23D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M17.5 10C17.5 14.1425 14.1425 17.5 10 17.5C5.8575 17.5 2.5 14.1425 2.5 10C2.5 5.8575 5.8575 2.5 10 2.5C11.2108 2.5 12.3508 2.79417 13.3633 3.30333" stroke="#0AC23D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
  )
}

export default CompletedIcon